import { faPlus, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Button, InputAdornment, TextField } from '@mui/material';

type InsightsProps = {
  values: string[];
  onChange: (values: string[]) => void;
  error?: string;
};

function moveItem(array: string[], fromIndex: number, toIndex: number) {
  const item = array.splice(fromIndex, 1)[0];
  array.splice(toIndex, 0, item);
  return array;
}

export const Insights = ({ values = [], onChange, error }: InsightsProps) => {
  const handleValueDelete = (index: number) => {
    onChange(values.filter((val, i) => i !== index));
  };

  const handleValueChange = (value: string, index: number) => {
    onChange(values.map((val, i) => (i == index ? value : val)));
  };

  const addNewValue = () => {
    onChange([...values, '']);
  };

  const onOrderChange = (index: number, order: 1 | -1) => {
    onChange(moveItem(values, index, index + order));
  };

  return (
    <div className="flex flex-col gap-4 w-full">
      <>
        <div className="flex flex-col gap-4 w-full">
          {values.map((value, index) => (
            <div key={index} className="w-full flex gap-4">
              <TextField
                value={value}
                onChange={(ev) => handleValueChange(ev.target.value, index)}
                className="w-full"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <FontAwesomeIcon
                        icon={faXmark}
                        onClick={() => handleValueDelete(index)}
                        className="cursor-pointer"
                      />
                    </InputAdornment>
                  ),
                }}
              />
              {values.length > 1 ? (
                <div className="flex gap-2">
                  <Button
                    variant="text"
                    className="min-w-[20px]"
                    disabled={index === 0}
                    onClick={() => onOrderChange(index, -1)}
                    data-testid={`moveUp-${index}`}
                  >
                    <FontAwesomeIcon icon={faChevronUp} />
                  </Button>
                  <Button
                    variant="text"
                    className="min-w-[20px]"
                    disabled={index === values.length - 1}
                    onClick={() => onOrderChange(index, 1)}
                    data-testid={`moveDown-${index}`}
                  >
                    <FontAwesomeIcon icon={faChevronDown} />
                  </Button>
                </div>
              ) : null}
            </div>
          ))}
        </div>
        {error ? (
          <Alert severity="error" className="bg-red-100">
            {error}
          </Alert>
        ) : null}
      </>
      <div>
        <Button
          startIcon={<FontAwesomeIcon icon={faPlus} />}
          variant="contained"
          onClick={addNewValue}
          data-testid="add"
        >
          Add Insight
        </Button>
      </div>
    </div>
  );
};
